module.exports = __webpack_public_path__ + "static/img/img_hifive.d86b488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img_hifive.png
// module id = aWce
// module chunks = 1